// Copyright (c) 2026 IOTA Stiftung
// SPDX-License-Identifier: Apache-2.0

export enum CoinTrust {
    Native = 'native',
    Recognized = 'recognized',
}

export enum CoinOwnerType {
    Address = 'AddressOwner',
    Object = 'ObjectOwner',
    Shared = 'Shared',
    Immutable = 'Immutable',
}
